// 导出一个函数，用于获取blob文件
export function getBlob(url, cb) {
  // 创建一个新的XMLHttpRequest对象
  const xhr = new XMLHttpRequest();
  // 设置xhr的请求方式为GET
  xhr.open("GET", url, true);
  // 设置xhr的响应类型为blob
  xhr.responseType = "blob";
  // 设置xhr加载完成后的回调函数
  xhr.onload = function (e) {
    // 如果xhr的状态码为200，则调用cb函数
    if (xhr.status === 200) {
      cb(xhr.response);
    }
  };
  // 发送xhr
  xhr.send();
}

// 导出一个函数，用于保存文件
export function saveAs(blob, filename) {
  // 如果浏览器支持msSaveOrOpenBlob
  if (window.navigator.msSaveOrOpenBlob) {
    // 使用window.navigator.msSaveBlob保存文件
    window.navigator.msSaveBlob(blob, filename);
  } else {
    // 创建一个a标签
    const link = document.createElement("a");
    // 获取body元素
    const body = document.querySelector("body");
    // a标签的href属性设置为blob的URL
    link.href = window.URL.createObjectURL(new Blob([blob], { type: "application/vnd.ms-excel" }));
    // a标签的download属性设置为filename
    link.download = filename;
    // 修复Firefox
    link.style.display = "none";
    // 将a标签添加到body中
    body.appendChild(link);
    // 点击a标签
    link.click();
    // 从body中移除a标签
    body.removeChild(link);
    // 取消URL的使用
    window.URL.revokeObjectURL(link.href);
  }
}

// 导出一个函数，用于下载文件
export async function downloadFile(url, filename) {
  if (isSafari()) {
    const link = document.createElement("a");
    link.href = url;
    //去掉filename后缀
    link.download = filename.replace(/\.[^/.]+$/, "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    // 获取url指向的blob对象，回调函数内执行
    getBlob(url, (blob) => {
      // 使用saveAs方法保存blob对象，文件名称为filename
      saveAs(blob, filename);
    });
  }
}

// 判断是否为safari浏览器
export function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
